<template>
    <MainLayout></MainLayout>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import MainLayout from "@/components/layout/MainLayout.vue";
import { EVENT_NAME_LOADED_LOCALE, i18nData } from "@/i18n";
import { useAppEventListener } from "@/composables/useAppEventListener";
import { useI18n } from "@/composables/useI18n";

defineOptions({ name: "App" });

const { updateLocale } = useI18n();

const onLoadedLocale = (locale: string) => {
    updateLocale(locale);
};

useAppEventListener(EVENT_NAME_LOADED_LOCALE, onLoadedLocale);

onMounted(() => {
    if (i18nData.locale) {
        updateLocale(i18nData.locale);
    }
});
</script>

<style>
/* Common style */

@import "@/style/main.css";

@import "@/style/theme.css";

@import "@/style/forms.css";

@import "@/style/tables.css";

@import "@/style/modals.css";

@import "@/style/auth-page.css";

@import "@/style/scroll-bar.css";

/* Layout */

@import "@/style/layout/main-layout.css";

@import "@/style/layout/loader.css";

@import "@/style/layout/top-bar.css";

@import "@/style/layout/account-menu.css";

@import "@/style/layout/page.css";

@import "@/style/layout/page-tabs.css";

@import "@/style/layout/cards.css";

@import "@/style/layout/account-settings.css";

@import "@/style/layout/pagination.css";

@import "@/style/layout/side-bar.css";

@import "@/style/layout/snack-bar.css";

@import "@/style/layout/monitoring.css";
</style>
